import {
  EPTSessionType,
  EPTTimestampType,
} from '@tableau/microview-communication-service/lib/src/channelDefinitions/SearchEPTChannelDefinitions';
import { call, put, select, fork } from 'redux-saga/effects';
import { PerformSearchAction } from '../actions/ActionTypes';
import { performSearchFailed } from '../actions/PerformSearchFailedAction';
import { performSearchSucceeded } from '../actions/PerformSearchSucceededAction';
import { performSearchSucceededWithMetadata } from '../actions/PerformSearchSucceededWithMetadataAction';
import { ContentDefinitions } from '../models/contentDefinitions';
import { ContentType } from '../models/ContentType';
import { SearchResultItem, MixedContentTypeSearchResult } from '../models/SearchResultTypes';
import { selectFilterQuery } from '../selectors/selectSingleContentTypeSearchResult';
import { ContentService } from '../services/ContentService';
import { SearchEPTService } from '../services/SearchEPTService';
import { FilterQuery } from '../state/FilterState';

export const INITIAL_PAGESIZE_SLICE: number = 20;

export function* performSearchV2(action: PerformSearchAction) {
  SearchEPTService.instance.mark(EPTSessionType.fullSearch, action.searchTerm, EPTTimestampType.initialUIRendered);
  SearchEPTService.instance.mark(EPTSessionType.fullSearch, action.searchTerm, EPTTimestampType.sendingRequestsToServerSide);

  const filters: FilterQuery = yield select(selectFilterQuery);

  const mixedContentTypeResult: MixedContentTypeSearchResult = yield call(
    ContentService.instance.fetchAllContent,
    action.searchTerm,
    0,
    INITIAL_PAGESIZE_SLICE,
    filters
  );

  // check if mixedContentTypeResult has an error (if so, all crass calls failed)
  // dispath a failed search so that the oops page shows
  if (mixedContentTypeResult.error) {
    yield put(performSearchFailed(mixedContentTypeResult.error));
  } else {
    SearchEPTService.instance.mark(EPTSessionType.fullSearch, action.searchTerm, EPTTimestampType.gotResponseFromServerSide);
    yield put(performSearchSucceeded(mixedContentTypeResult));
  }

  for (const contentType in ContentDefinitions) {
    const currentContentType = contentType as ContentType;
    if (mixedContentTypeResult.map[currentContentType].list.length > 0) {
      yield fork(fetchContentMetadata, currentContentType, mixedContentTypeResult.map[currentContentType].list);
    }
  }
}

function* fetchContentMetadata(contentType: ContentType, searchResultItems: SearchResultItem[]) {
  const metadataResult: { contentType: ContentType; data: SearchResultItem[] } | null = yield call(
    ContentService.instance.fetchContentMetadata,
    contentType,
    searchResultItems
  );
  if (metadataResult) {
    yield put(performSearchSucceededWithMetadata(contentType, metadataResult.data));
  }
}
